import React from 'react';
import { connect } from 'react-redux';
import PipeParameters from './pipeParameters.component';
import { setPipeParameterValue } from '../../../../actions/pipe-calculations.actions';
import { setPipeDesign } from "../../../../actions/pipe-bed-actions";
import { resetPipeAccessories } from "../../../../actions/floating-tool-pipes-actions";
import SimpleLoader from "../../../SimpleLoader";
import BaseComponent from "../../../../lib/base-component";
import pipeSelectors from "../../../../lib/pipe-selectors";
import { InchUtility } from "../../../../lib/pipe-dataset";

const WatchedPropCases = {
    SET_PIPE_DESIGN: "SET_PIPE_DESIGN",
    SET_PIPE_PERIMETER: "SET_PIPE_PERIMETER",
    SET_PIPE_NOMINAL_SIZE: "SET_PIPE_NOMINAL_SIZE",
    SET_PIPE_STONE_POROSITY: "SET_PIPE_STONE_POROSITY"
};

class PipeParametersContainer extends BaseComponent {
    static watchedProps = {
        [WatchedPropCases.SET_PIPE_NOMINAL_SIZE]: [
            "pipeNominalDiameter"
        ],
        [WatchedPropCases.SET_PIPE_DESIGN]: [
            "pipeNominalDiameter",
            "pipeFitting",
            "pipeFlowDirection",
            "pipeStoneAbove",
            "pipeStoneBelow",
            "pipeStonePorosity"
        ],
        [WatchedPropCases.SET_PIPE_PERIMETER]: [
            "pipePerimeterOffset"
        ],
        [WatchedPropCases.SET_PIPE_STONE_POROSITY]: [
            "pipeNominalDiameter",
            "pipeFitting"
        ]
    };
    static _isLoaded = false;

    onPropHasChanged( prevProps, watchedPropCase ) {
        let {
            availableWidth,
            availableLength,
            actualWidth,
            actualLength,
            pipePerimeterOffset,
            calculatedStoneBedMinimumWidth,
            calculatedStoneBedMinimumLength,
            stoneBedMinimumWidth,
            stoneBedMinimumLength
        } = this.props;

        switch (watchedPropCase) {
            case WatchedPropCases.SET_PIPE_NOMINAL_SIZE:
                if (actualWidth.ft < calculatedStoneBedMinimumWidth) {
                    actualWidth = new InchUtility(calculatedStoneBedMinimumWidth * 12);
                }

                if (actualLength.ft < calculatedStoneBedMinimumLength) {
                    actualLength = new InchUtility(calculatedStoneBedMinimumLength * 12);
                }

                if (availableWidth < stoneBedMinimumWidth) {
                    this.props.setPipeParameterValue("pipeAvailableWidth", stoneBedMinimumWidth);
                }

                if (availableLength < stoneBedMinimumLength) {
                    this.props.setPipeParameterValue("pipeAvailableLength", stoneBedMinimumLength);
                }

                this.props.resetPipeAccessories();
                this.props.setPipeDesign(actualWidth.ft, actualLength.ft);
                break;
            case WatchedPropCases.SET_PIPE_DESIGN:
                return this.props.setPipeDesign(actualWidth.ft, actualLength.ft);
            case WatchedPropCases.SET_PIPE_PERIMETER:
                const perimeterOffsetDiff = (pipePerimeterOffset - prevProps.pipePerimeterOffset) * 2;

                return this.props.setPipeDesign(
                    Math.ceil(
                        actualWidth.in + perimeterOffsetDiff) / 12,
                    Math.ceil(actualLength.in + perimeterOffsetDiff) / 12
                );
            case WatchedPropCases.SET_PIPE_STONE_POROSITY:
                if (this.props.pipeStonePorosity !== 40) {
                    this.props.setPipeParameterValue("pipeStonePorosity", 40);
                }
                break;
            default:
                break;
        }
    }

    render() {
        const {
            lbl,
            unit,
            lang,
            content
        } = this.props;

        return (
            <SimpleLoader onLoad={this.onLoad}>
                <PipeParameters
                    lbl={lbl}
                    unit={unit}
                    lang={lang}
                    content={content}
                />
            </SimpleLoader>
        );
    }

    onLoad = () => {
        if (!PipeParametersContainer._isLoaded) {
            this.props.setPipeDesign();
            PipeParametersContainer._isLoaded = true;
        }
    }
}

const mapStateToProps = ( state ) => {
    const {
        width: actualWidth,
        length: actualLength
    } = state.pipeBed.dimensions;

    return {
        actualWidth,
        actualLength,
        lbl: state.localization.lbl,
        unit: state.localization.unit,
        lang: state.localization.lang,
        content: state.localization.content,
        pipeType: state.pipeGlobals.pipeType,
        pipeFitting: state.pipeGlobals.pipeFitting,
        pipeSystemType: state.pipeGlobals.pipeSystemType,
        pipeStoneAbove: state.pipeGlobals.pipeStoneAbove,
        pipeStoneBelow: state.pipeGlobals.pipeStoneBelow,
        availableWidth: state.pipeGlobals.pipeAvailableWidth,
        availableLength: state.pipeGlobals.pipeAvailableLength,
        pipeNominalDiameter: state.pipeGlobals.pipeNominalDiameter,
        pipePerimeterOffset: state.pipeGlobals.pipePerimeterOffset,
        stoneBedMinimumWidth: pipeSelectors.stoneBedMinimumWidth(state),
        stoneBedMinimumLength: pipeSelectors.stoneBedMinimumLength(state),
        calculatedStoneBedMinimumWidth: pipeSelectors.calculatedStoneBedMinimumWidth(state),
        calculatedStoneBedMinimumLength: pipeSelectors.calculatedStoneBedMinimumLength(state),
    };
};

const mapDispatchToProps = {
    setPipeDesign,
    resetPipeAccessories,
    setPipeParameterValue,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PipeParametersContainer);



// WEBPACK FOOTER //
// ./src/components/LeftMenu/SystemParameters/Pipes/pipeParameters.container.js